export const initialState = {
    basket: [],
    selectedSize: '', // Add selectedSize to the initial state
};

//selector 
export const getBasketTotal = (basket) =>
basket?.reduce((amount, item) => item.price + amount, 0); 

const reducer = (state, action) => {
    // if(action.type === 'ADD_TO_BASKET'){
    //     return {
    //         ...state, basket: [...state.basket, action.item],
    //     };
    // }

    // else{
    //     return state;
    // }
    switch(action.type){
        case 'ADD_TO_BASKET':
            return {
                ...state, basket: [...state.basket, action.item],
            };
        case 'SET_SELECTED_SIZE': // Add a new action type for setting the selected size
            return {
              ...state,
              selectedSize: action.size,
            };
        case "REMOVE_FROM_BASKET":
            const index = state.basket.findIndex((basketItem)=>basketItem.id === action.id);
            let newBasket = [...state.basket];
            if(index>=0){
                    newBasket.splice(index, 1);
            }
            else{
                console.warn('Item is not in cart')
            }
            // return { ...state, basket: state.basket.filter(item => item.id !== action.id)}
                return {
                    ...state, basket : newBasket
                }
                default:
        return state
    }

   
};

export default reducer;